<template>
	<div class="login-container" v-if="show && from">
		<IdaasLogin v-if="from === 'IDAAS'" @login="goToOauth" />
		<SrmLogin v-else-if="from === 'SRM'" @login="goToOauth" />
		<WmsLogin v-else-if="from === 'ULTRA_WMS'" @login="goToOauth" />
		<OmsLogin :from="from" v-else @login="goToOauth" />
	</div>
	<div class="flex-c-c" v-else>
		<img class="loading" src="@/assets/img/loading.gif" alt="" />
	</div>
</template>

<script setup>
import { onMounted, ref } from "vue"
import { useRoute, useRouter } from "vue-router"
import { useStore } from "vuex"
import OmsLogin from "./omsLogin.vue"
import WmsLogin from "./wmsLogin.vue"
import IdaasLogin from "./idaasLogin.vue"
import SrmLogin from "./srmLogin.vue"
import { setCookie } from "@/common/utils/cookie"
import { localSet } from "@/common/utils"
import axios from "@/common/axios"
import api from "@/common/api/api"
import { getSingleSignOnURL } from "@/common"

const singleSignOnURL = getSingleSignOnURL()
const router = useRouter()
const store = useStore()
const route = useRoute()
const show = ref(true)
const from = ref("")

const queryValue = (value) => (Array.isArray(value) ? value[0] : value)

const buildOauthAuthorizeUrl = () => {
	const url = new URL("/api/open/oauth/authorize", window.location.origin)
	const query = {
		app_key: queryValue(route.query.app_key),
		response_type: queryValue(route.query.response_type) || "code",
		state: queryValue(route.query.state),
		scope: queryValue(route.query.scope),
		terminal: "PC",
		redirect_uri: queryValue(route.query.g),
		idaas_uri: window.location.origin,
	}
	Object.entries(query).forEach(([key, value]) => {
		if (value !== undefined && value !== null && value !== "") {
			url.searchParams.set(key, String(value))
		}
	})
	return url.toString()
}

const redirectWithAuthCode = (result) => {
	const callback = queryValue(route.query.g)
	if (!callback || !result?.authCode) {
		throw new Error("登录回调地址或 authCode 缺失")
	}

	const url = new URL(String(callback), window.location.origin)
	url.searchParams.set("code", result.authCode)
	const state = result.state || queryValue(route.query.state)
	if (state && state !== "null") url.searchParams.set("state", state)
	if (result.gatewayUri) url.searchParams.set("gateway_uri", result.gatewayUri)
	if (result.terminal) url.searchParams.set("terminal", result.terminal)
	window.location.assign(url.toString())
}

onMounted(() => {
	show.value = true
	from.value = route.query.scope
	if (route.query.gateway_uri) {
		show.value = false
		localStorage.setItem("apiURL", route.query.gateway_uri)
	}
	if (route.query.code) {
		oauthLogin(route.query.code)
		return
	}
	if (!from.value && !route.query.code) {
		window.location.href = singleSignOnURL
	}
})
const goToOauth = async (res) => {
	if (res?.authCode) {
		try {
			redirectWithAuthCode(res)
		} catch (error) {
			console.error(error)
			window.location.href = singleSignOnURL
		}
		return
	}

	if (!res?.user) {
		return
	}

	setCookie({ d_session_id: res.user?.sessionId })
	if (res.user.originalMerchantCode === "GEEZ") {
		await getDataList()
	}
	localSet("token", res)
	localSet("appInfoAlert", "open")
	localSet("userAccount", res.user.userName)
	store.dispatch("user/LOGIN", res)

	window.location.href = buildOauthAuthorizeUrl()
}

const getDataList = () => {
	const data = {
		page_no: 1,
		page_size: 1000,
		status: true,
	}
	axios
		.post(api.getMerchantList, data)
		.then((res) => {
			localSet("merchantList", res.list)
		})
		.catch((err) => {
			console.log(err)
		})
}
const oauthLogin = (code) => {
	axios
		.post(api.authorizeOauth, {
			authCode: code,
		})
		.then((res) => {
			setCookie({ Authorization: res })
			setTimeout(() => {
				jump()
			}, 100)
		})
		.catch((err) => {
			console.log(err)
			window.location.href = singleSignOnURL
		})
}

const jump = () => {
	router.push("/overview")
}
</script>

<style scoped>
.login-container {
	height: 100vh;
}

.flex-c-c {
	width: 100vw;
	height: 100vh;
	display: flex;
	justify-content: center;
	align-items: center;

	.loading {
		width: 100px;
		height: 100px;
		display: block;
	}
}
</style>
